const AutoCompleteDefault = (arr, value, key = 'id') =>
  arr.find((item) => item[key] === value);

export default AutoCompleteDefault;
